import { ThemeColors } from '~/themes/colors'

export interface SiteNavigationCollapseTabColors {
  Content: {
    Background: {
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
  Icon: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
  }
  FontColor: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
  }
}

export const SiteNavigationCollapseTabColors: SiteNavigationCollapseTabColors =
  {
    Content: {
      Background: {
        Hover: {
          default: 'gray.400',
        },
        Active: {
          default: 'gray.500',
        },
      },
    },
    Icon: {
      Default: {
        default: 'gray.800',
      },
      Hover: {
        default: 'gray.1000',
      },
      Active: {
        default: 'gray.1300',
      },
    },
    FontColor: {
      Default: {
        default: 'gray.800',
      },
      Hover: {
        default: 'gray.1000',
      },
      Active: {
        default: 'gray.1300',
      },
    },
  }
